// src/components/ui/TopLoader.jsx
import React from 'react';

/**
 * TopLoader HoraPilot — loader corporate professionnel
 * Se place en haut de la zone de contenu (pas fixed sur toute la page)
 * 
 * Usage:
 *   <TopLoader visible={loading} />
 */

const TopLoader = ({ visible = false }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: visible ? '3px' : '0px',
        zIndex: 99999,
        overflow: 'hidden',
        transition: 'height 0.2s ease',
      }}
    >
      {/* Fond */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: '#88b9c5',
          opacity: 0.12,
        }}
      />

      {/* Barre 1 — rapide */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          height: '100%',
          backgroundColor: '#88b9c5',
          borderRadius: '0 2px 2px 0',
          animation: 'hp-bar1 2s cubic-bezier(0.65, 0, 0.35, 1) infinite',
        }}
      />

      {/* Barre 2 — décalée, plus lente */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          height: '100%',
          backgroundColor: '#6fa3b0',
          borderRadius: '0 2px 2px 0',
          opacity: 0.6,
          animation: 'hp-bar2 2s cubic-bezier(0.65, 0, 0.35, 1) 0.4s infinite',
        }}
      />

      <style>{`
        @keyframes hp-bar1 {
          0% { left: -30%; width: 30%; }
          50% { left: 30%; width: 50%; }
          100% { left: 110%; width: 20%; }
        }
        @keyframes hp-bar2 {
          0% { left: -20%; width: 20%; }
          50% { left: 40%; width: 40%; }
          100% { left: 110%; width: 15%; }
        }
      `}</style>
    </div>
  );
};

export default TopLoader;